import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer className="bg-gradient-to-br from-white to-primary-50 text-gray-900">
      <div className="container-custom py-8">
        <div className="text-center">
          <h3 className="text-2xl font-bold text-primary-500 mb-4">BD Analytics</h3>
          <p className="text-gray-600">
            © 2024 BD Analytics. Todos os direitos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 